export default (permissions: string[]) => {
  const authStore = useAuthStore()

  if (authStore.getIsAdmin || !permissions.length) return true

  return permissions.some((p) => authStore.getPermissions?.includes(p))
}
